"use strict";
// @df/api - Internal utility functions (self-contained, no external @df/* dependencies)
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorBoundary = void 0;
// Error boundary utilities
exports.errorBoundary = {
    // Log error with context
    logError: (error, context) => {
        console.error(`[Error${context ? ` - ${context}` : ''}]:`, error);
    },
    // Get user-friendly error message
    getUserMessage: (error) => {
        if (error.message.includes('Network')) {
            return 'Network error. Please check your connection and try again.';
        }
        if (error.message.includes('401')) {
            return 'Authentication required. Please log in again.';
        }
        if (error.message.includes('403')) {
            return 'Access denied. You do not have permission to perform this action.';
        }
        if (error.message.includes('404')) {
            return 'The requested resource was not found.';
        }
        if (error.message.includes('429')) {
            return 'Too many requests. Please wait a moment and try again.';
        }
        if (error.message.includes('500')) {
            return 'Server error. Please try again later.';
        }
        return 'An unexpected error occurred. Please try again.';
    }
};
